function isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
/** SurveyJS file questions store values as { name, type, content } where content
 * is a base64 data URI. Detect a single such file value. */
function isFileAttachmentObject(value) {
    return (isPlainObject(value) &&
        typeof value.name === 'string' &&
        typeof value.content === 'string' &&
        value.content.length > 0);
}
/** Walk the survey data and collect every file attachment with its base64 content. */
export function extractAttachments(data) {
    const attachments = [];
    function walk(value, path) {
        if (isFileAttachmentObject(value)) {
            attachments.push({
                fieldPath: path,
                name: value.name,
                type: typeof value.type === 'string' ? value.type : '',
                content: value.content,
            });
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((item, index) => walk(item, `${path}[${index}]`));
            return;
        }
        if (isPlainObject(value)) {
            for (const [key, child] of Object.entries(value)) {
                walk(child, path ? `${path}.${key}` : key);
            }
        }
    }
    walk(data, '');
    return attachments;
}
/** Return a deep clone of the survey data with the heavy base64 `content` removed
 * from file attachment values, keeping the lightweight { name, type } metadata so
 * the submitted form still records which files were attached. */
export function stripAttachmentContent(data) {
    function clone(value) {
        if (isFileAttachmentObject(value)) {
            const { content: _content, ...rest } = value;
            return rest;
        }
        if (Array.isArray(value)) {
            return value.map(clone);
        }
        if (isPlainObject(value)) {
            const result = {};
            for (const [key, child] of Object.entries(value)) {
                result[key] = clone(child);
            }
            return result;
        }
        return value;
    }
    const cloned = clone(data);
    return isPlainObject(cloned) ? cloned : {};
}
/** The attachment workflow expects raw base64, so strip a `data:...;base64,` prefix
 * if present. Falls back to the original string when no data-URI prefix exists. */
export function toRawBase64(content) {
    const commaIndex = content.indexOf('base64,');
    if (commaIndex >= 0) {
        return content.slice(commaIndex + 'base64,'.length);
    }
    return content;
}
